import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import { objectAsParams } from '../../../helpers/objectToQueryParams'
import moment from 'moment';

class AplicacionPagos extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'pago/one', saveUrl: 'pago/save', backUrl: '/Ventas/Pagos' },
      new Form([
        Form.Field('select', 'id_cuenta_bancaria', 'Cuenta', '', [Validators.required], 6),
        Form.Field('date', 'fecha_deposito', 'Fecha Deposito', '', [Validators.required], 6),
        Form.Field('select', 'id_plazo', 'Plazo', '', [Validators.required], 6, []),
        Form.Field('select', 'id_sucursal', 'Sucursal', '', [Validators.required], 6),
      ], ['Buscar'], 'Control de depositos'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()

    // console.log(this.props);
    setTimeout(() => this.updatePlazos(), 1000);
  }

  componentDidUpdate(prevProps) {
    const { params: prevParams } = prevProps.match;
    const { params } = this.props.match;
    if (prevParams.type !== params.type)
      this.updatePlazos();
    // console.log(prevProps, this.props);
  }

  updatePlazos = () => {
    // [{ Label: 'Contado', Value: '1' }, { Label: 'Credito', Value: '2' }]
    const { params } = this.props.match;
    let options = [];
    if (params.type === "Contado") {
      options.push({ Label: 'Contado', Value: '1' })
    }
    else if (params.type === "Credito") {
      options.push({ Label: 'Credito', Value: '2' })
    }
    let newForm = Form.FieldMod(this.state.FormData, 'id_plazo', 'Options', options);
    newForm = Form.Patch(newForm, { id_plazo: options[0].Value });
    this.setState({ FormData: newForm });
  }

  formData = async (form) => {
    const Res = await Http.get('pago/form');

    if (!Res.error) {
      const { CuentasBancarias, Sucursales } = Res.data;
      let newForm = Form.FieldOptions(form, 'id_cuenta_bancaria', CuentasBancarias, 'id', 'cuenta');
      newForm = Form.FieldOptions(newForm, 'id_sucursal', Sucursales, 'id', 'sucursal');
      return newForm;
    }
  }

  onSubmit = async (i, vals) => {
    vals.fecha_deposito = moment(vals.fecha_deposito).format('YYYY-MM-DD')
    this.props.history.push(`/Cobranza/ApliacionPago/Depositos?${objectAsParams(vals)}`)
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(AplicacionPagos)
